"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkUpdateData = void 0;
const utils_1 = require("../../utils");
const lodash_1 = require("lodash");
var BookmarkUpdateData;
(function (BookmarkUpdateData) {
    function updateFields(data) {
        const updateFields = {};
        if (!(0, lodash_1.isUndefined)(data.progress))
            updateFields['progress'] = data.progress;
        if (!(0, lodash_1.isUndefined)(data.seenAt))
            updateFields['seenAt'] = data.seenAt;
        if (!(0, lodash_1.isUndefined)(data.assignmentInfo))
            updateFields['assignmentInfo'] = data.assignmentInfo;
        if (!(0, lodash_1.isUndefined)(data.groupId))
            updateFields['groupId'] = data.groupId;
        if (!(0, lodash_1.isUndefined)(data.isHidden))
            updateFields['isHidden'] = data.isHidden;
        if (!(0, lodash_1.isUndefined)(data.isArchived))
            updateFields['isArchived'] = data.isArchived;
        if (!(0, lodash_1.isUndefined)(data.grade))
            updateFields['grade'] = data.grade;
        if (!(0, lodash_1.isUndefined)(data.testPhase))
            updateFields['testPhase'] = data.testPhase;
        if (!(0, lodash_1.isUndefined)(data.hasUnseenComments))
            updateFields['hasUnseenComments'] = data.hasUnseenComments;
        if (!(0, lodash_1.isUndefined)(data.startDate))
            updateFields['startDate'] = data.startDate;
        if (!(0, lodash_1.isUndefined)(data.closeDate))
            updateFields['closeDate'] = data.closeDate;
        if (!(0, lodash_1.isUndefined)(data.module))
            updateFields['module'] = data.module;
        if (!(0, lodash_1.isUndefined)(data.order))
            updateFields['order'] = data.order;
        const cleaned = (0, utils_1.omitDeepUndefined)(updateFields);
        if (!(0, lodash_1.isEmpty)(cleaned)) {
            cleaned['modifiedAt'] = Date.now();
        }
        return cleaned;
    }
    BookmarkUpdateData.updateFields = updateFields;
})(BookmarkUpdateData || (exports.BookmarkUpdateData = BookmarkUpdateData = {}));
//# sourceMappingURL=BookmarkUpdateData.js.map